export const parseLyrics = (
  lyricsLrc?: string | null,
): {
  time: number
  text: string
}[] => {
  if (!lyricsLrc?.trim()) {
    return []
  }
  const lines = lyricsLrc.split('\n')
  const parsedLyrics = [] as { time: number; text: string }[]

  lines.forEach((line) => {
    const match = line.match(/\[(\d{2}:\d{2}\.\d{2})\](.*)/)
    if (match) {
      const timeStr = match[1] // 时间戳，如 "00:00.24"
      const text = match[2]
      if (text) {
        // 将时间转换为秒
        const [minutes, seconds] = timeStr.split(':')
        const totalSeconds =
          Number.parseInt(minutes) * 60 + Number.parseFloat(seconds)
        parsedLyrics.push({ time: totalSeconds, text })
      }
    }
  })

  return parsedLyrics
}

/**
 * 解析纯文本歌词（无时间戳），作为 LRC 歌词的降级方案
 * 返回格式与 parseLyrics 一致，但 time 都为 -1（表示无时间信息）
 */
export const parsePlainLyrics = (
  lyrics?: string | null,
): {
  time: number
  text: string
}[] => {
  if (!lyrics?.trim()) {
    return []
  }

  return lyrics
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
    .map((text) => ({ time: -1, text }))
}
